import { useState } from "react";

import ButtonMenu from "../atoms/buttons/ButtonMenu";

import ManualTransactionsInput from "../inputs/emissions/ManualTransactionsInput";
import MultipleTransactionsUploader from "../inputs/csv-uploaders/MultipleTransactionsUploader";
import EmissionsVolumeForm from "../inputs/emissions/EmissionsVolumeForm";
import usePermissions from "../../helpers/hooks/usePermissions";

const AddEmissionsMenu = ({ fullWidth }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { canEdit } = usePermissions();

  const inputDialogs = {
    transactionsCsv: (
      <MultipleTransactionsUploader
        setOpen={setDialogOpen}
        open={!!dialogOpen}
      />
    ),
    manualTransactions: (
      <ManualTransactionsInput setDialogOpen={setDialogOpen} />
    ),
    volumeTransactions: <EmissionsVolumeForm setDialogOpen={setDialogOpen} />
  };

  if (!canEdit) {
    return null;
  }

  return (
    <>
      {dialogOpen && inputDialogs[dialogOpen]}
      <ButtonMenu
        color="secondary"
        variant="contained"
        fullWidth={fullWidth}
        menuOptions={[
          {
            label: "Upload Emissions",
            onClick: () => setDialogOpen("transactionsCsv")
          },
          {
            label: "Add a Single Emission",
            onClick: () => setDialogOpen("manualTransactions")
          },
          {
            label: "Add Emission Volume",
            onClick: () => setDialogOpen("volumeTransactions")
          }
        ]}
      />
    </>
  );
};
export default AddEmissionsMenu;
